import * as React from 'react';
import { Info } from 'lucide-react';

import { cn } from '@/lib/tailwind-utils.js';
import { Tooltip } from '../tooltip.js';

export interface TooltipPillProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  variant?: 'default';
  labelTooltip?: React.ReactNode;
}

const TooltipPill = React.forwardRef<HTMLDivElement, TooltipPillProps>(
  ({ className, children, variant = 'default', labelTooltip, ...props }, ref) => {
    const variantStyles = {
      default: 'bg-gray-100 text-gray-700',
    };
    const RightIcon = (
      <Tooltip
        trigger={
          <Info className="h-4 w-4 group-data-[state=open]/tooltip:bg-gray-600 group-data-[state=open]/tooltip:text-white rounded-full transition-colors duration-200" />
        }
      >
        {labelTooltip}
      </Tooltip>
    );

    return (
      <div
        ref={ref}
        className={cn(
          // Base styles - pill shape with rounded corners
          'group inline-flex items-center justify-center gap-2 px-3 py-2 rounded-full',
          // Variant styles
          variantStyles[variant],
          className,
        )}
        {...props}
      >
        <span className="flex-1 text-center">{children}</span>
        {RightIcon}
      </div>
    );
  },
);

TooltipPill.displayName = 'TooltipPill';

export { TooltipPill };
